import { gql } from "apollo-boost";

const SHARE_ITEM = gql`
  mutation ShareItem(
    $from: String!
    $to: String!
    $item_id: String!
    $item_type: String!
    $message: String!
    $copy_to_myself: Boolean!
    $g_recaptcha_response: String
  ) {
    share_item(
      email_from: $from
      to: $to
      item_id: $item_id
      item_type: $item_type
      message: $message
      copytomyself: $copy_to_myself
      g_recaptcha_response: $g_recaptcha_response
    ) {
      message
      email
    }
  }
`;

export default SHARE_ITEM;
